// add the rule here
$.validator.addMethod(
  'valueNotEquals',
  function (value, element, arg) {
    return arg !== value
  },
  'El valor no debe ser igual a arg.'
)

$.validator.addMethod(
  'comparisonhigher',
  function (value, element, arg) {
    let inputVal = parseInt(value)
    if(isNaN(inputVal)){
      inputVal = 0
    }
    let inputValComparar = parseInt($(arg).val())
    if(isNaN(inputValComparar)){
      inputValComparar = 0
    }
    return inputValComparar < inputVal
  },
  'El valor no debe ser igual a arg.'
)

var listaFormularios = {}

$.fn.validarForm = function (callback, extraConfigs = null, delay = 0) {
  let $form = $(this)
  if (listaFormularios[$form.attr('id')] != null) {
    listaFormularios[$form.attr('id')].resetForm()
    listaFormularios[$form.attr('id')].destroy()
  }
  setTimeout(() => {
    let $inputs = $form.find('input[data-validation]')
    let $textareas = $form.find('textarea[data-validation]')
    $inputs = [...$inputs,...$textareas]
    let $selects = $form.find('select[data-validation]')
    let configs = {
      lang: 'es',
      errorElement: 'span',
      rules: {},
      messages: {},
      submitHandler: function (form) {
        callback(form)
      },
    }

    for (let index = 0; index < $inputs.length; index++) {
      let $input = $($inputs[index])

      let required = $input[0].getAttribute('data-validation-required') != null

      if (
        extraConfigs != null &&
        extraConfigs[$input.attr('name')] != null &&
        extraConfigs[$input.attr('name')].required != null
      ) {
        required = extraConfigs[$input.attr('name')].required
      }
      configs.rules[$input.attr('name')] = {
        required: required,
        number:
          $input.data('validation-number') != null && $input.data('validation-number').length > 0,
        email:
          $input.data('validation-email') != null && $input.data('validation-email').length > 0,
      }
      configs.messages[$input.attr('name')] = {
        required: $input.data('validation-required'),
        number: $input.data('validation-number'),
        email: $input.data('validation-email'),
      }



      if (
        $input.data('validation-equalto') != null &&
        $input.data('validation-equalto').length > 0
      ) {
        var equalto = $input.data('validation-equalto').split('|')
        if (equalto.length === 2) {
          configs.rules[$input.attr('name')].equalTo = equalto[0]
          configs.messages[$input.attr('name')].equalTo = equalto[1]
        }
      }

      if (
        $input.data('validation-minlength') != null &&
        $input.data('validation-minlength').length > 0
      ) {
        var minLength = $input.data('validation-minlength').split('|')
        if (minLength.length === 2) {
          configs.rules[$input.attr('name')].minlength = minLength[0]
          configs.messages[$input.attr('name')].minlength = minLength[1]
        }
      }
      if (
        $input.data('validation-maxlength') != null &&
        $input.data('validation-maxlength').length > 0
      ) {
        var maxLength = $input.data('validation-maxlength').split('|')
        if (maxLength.length === 2) {
          configs.rules[$input.attr('name')].maxlength = maxLength[0]
          configs.messages[$input.attr('name')].maxlength = maxLength[1]
        }
      }
      if (
        $input.data('validation-step') != null &&
        $input.data('validation-step').length > 0
      ) {
        var step = $input.data('validation-step').split('|')
        if (step.length === 2) {
          configs.rules[$input.attr('name')].step = step[0]
          configs.messages[$input.attr('name')].step = step[1]
        }
      }

      if (
        $input.data('validation-comparisonhigher') != null &&
        $input.data('validation-comparisonhigher').length > 0
      ) {
        var higher = $input.data('validation-comparisonhigher').split('|')
        if (higher.length === 2) {
          configs.rules[$input.attr('name')].comparisonhigher = higher[0]
          configs.messages[$input.attr('name')].comparisonhigher = higher[1]
        }
      }
    }

    for (let index = 0; index < $selects.length; index++) {
      let $select = $($selects[index])
      if (
        $select.data('validation-required') != null &&
        $select.data('validation-required').length > 0
      ) {
        configs.rules[$select.attr('name')] = {
          valueNotEquals: '',
        }
        configs.messages[$select.attr('name')] = {
          valueNotEquals: $select.data('validation-required'),
        }
      }
    }

    listaFormularios[$form.attr('id')] = $form.validate(configs)

    window.desactivarInputScroll($form);

  }, delay)
}
